export default __webpack_public_path__ + "static/media/microsoft-azure-icon.a8e3c7df.svg";